const themes = {
    1: '#5ccfe5',
    2: '#57e66d',
    3: '#f9c344',
    4: '#f42a68',
};

const DEFAULT_CATEGORY_COLOR = '#31C3DF';

export { themes, DEFAULT_CATEGORY_COLOR };
